<template>
  <b-card>
    <title-name />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import TitleName from '@/views/Admin/Defines/Banks/elements/Title.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    TitleName,
  },
}
</script>
